angular.module('note', ['core', 'clients', 'document'])
    .factory('Note', function ($resource) {
        return $resource('/crm/api/note/:id', {}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/note/table'},
            find: {method: 'GET', isArray: true},
            remove: {method: 'DELETE'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            updateTopic: {method: 'PUT', url: '/crm/api/note/:id/topic'},
            updateCalendar: {method: 'PUT', url: '/crm/api/note/:id/show-in-calendar'},
        });
    })
    .service('NoteService', function ($rootScope, $cookies, toastr, modals, Note, UserGroupService) {
        this.updateTopic = (id, topic) => {
            return Note.updateTopic({id: id}, {topic: topic}).$promise.then(() => {
                $rootScope.$broadcast('note.updated');
            });
        }
        this.toggleCalendar = (id, showInCalendar) => {
            return Note.updateCalendar({id: id}, {showInCalendar: showInCalendar}).$promise.then(() => {
                $rootScope.$broadcast('note.updated');
            });
        }
        this.editModal = entity => {
            return modals.open('app/note/edit-modal.html', 'NoteDialogController', entity, {size: "md"}, "$ctrl");
        };
        this.editModalSimple = entity => {
            return modals.open('app/note/edit-modal-simple.html', 'NoteDialogController', entity, {size: "md"}, "$ctrl");
        };
        this.editModalSimpleWith = (id, props) => {
            return Note.get({id: id}).$promise.then(entity => {
                angular.extend(entity, props);
                return this.editModalSimple(entity);
            })
        };
        this.addModal = params => {
            let entity = {
                id: null,
                dateOfIssue: moment().format("YYYY-MM-DD"),
                clients: [],
                subscriberGroups: [],
                subscribers: []
            };
            let group = $cookies.getObject("group-autoselect-selected");
            if (group)
                entity.subscriberGroups.push(group);

            angular.extend(entity, params);
            return this.editModal(entity);
        };
        this.addModalSimpleForGroup = (params, groupName) => {
            if(groupName == null)
                return this.addModalSimple(params);

            return UserGroupService.findByName(groupName).then(group => {
                if (group != null) {
                    params.subscriberGroups = [group];
                }
                return this.addModalSimple(params);
            })
        }
        this.addModalSimple = params => {
            let entity = {
                id: null,
                dateOfIssue: moment().format("YYYY-MM-DD"),
                clients: [],
                subscriberGroups: [],
                subscribers: []
            };

            let group = $cookies.getObject("group-autoselect-selected");
            if (group)
                entity.subscriberGroups.push(group);

            angular.extend(entity, params);
            return this.editModalSimple(entity);
        };
        this.showModal = id => modals.open('app/note/show-modal.html', 'NoteShowDialogController', {id: id}, {size: 'lg'}, "$ctrl");
        this.remove = item => {
            return modals.confirmDelete(item.topic, () => Note.delete({id: item.id}, () => $rootScope.$broadcast('note.deleted')).$promise);
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_NOTES",
            path: "/notes",
            ico: "fa fa-fw fa-comments-o",
            name: 'note.menu',
            order: 40
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('noteList', {
            parent: 'app',
            url: '/notes?{page:int}&{size:int}&sort&search&periodStart&periodEnd&{client:int}&priority&{type:int}',
            data: {
                authorities: ['ROLE_NOTES']
            },
            views: {
                'content@': 'noteList'
            },
            resolve: {
                page: (Note, $stateParams) => Note.table(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
            }
        });
        $stateProvider.state('noteShow', {
            parent: 'app',
            url: '/note/{id}',
            data: {
                authorities: ['ROLE_NOTES']
            },
            views: {
                'content@': 'noteShow'
            },
            resolve: {
                item: (Note, $stateParams) => Note.get({id: $stateParams.id}).$promise
            }
        });
        $stateProvider.state('noteShowDeprecated', {
            parent: 'app',
            url: '/notes/{id}',
            data: {
                authorities: ['ROLE_NOTES']
            },
            views: {
                'content@': 'noteShow'
            },
            resolve: {
                item: (Note, $stateParams) => Note.get({id: $stateParams.id}).$promise
            }
        });
    });
